import {api} from './requestGraphql'

const getPaymentTerms = async () => {
    try {
        const res = await api.post(
            '', {
                query: `
                    {
                        getTerms {
                            id
                            name
                            value
                        }
                    }
                `
            }
        )

        return res.data.data.getTerms
    } catch (e) {
        console.error(e)
    }
};

export default {
    getPaymentTerms,
}